import { withProps } from 'recompose'
import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getBrandTitle } from './selectors'
import { getHasActiveVehicleStatus } from 'selectors'
import BrandLines from './BrandLines'
import { showNewShopTiresModal } from '../../../NewShopTiresModal/actions'
import { GENERAL_SOURCE, YMME_NAME } from 'constant'

const mapStateToProps = state => ({
  title: getBrandTitle(state),
  hasActiveVehicle: getHasActiveVehicleStatus(state)
})

const withBrandLines = withProps(({
  showNewShopTiresModal
}) => ({
  addVehicleHandler: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

export default compose(
  withType({ type: 'BrandLines', placeholders: ['leftContent', 'rightContent']}),
  connect(mapStateToProps, { showNewShopTiresModal }),
  withBrandLines
)(BrandLines)
